import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function WelcomeBox() {
  const { t } = useTranslation(['home', 'common'])
  const [showContactModal, setShowContactModal] = useState(false)

  return (
    <>
      {/* Welcome Card */}
      <div className="card-neobrutalism h-full flex flex-col">
        <div className="flex items-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-2 text-neobrutalism-text" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          <h2 className="text-2xl font-black text-neobrutalism-text">
            {t('welcome.title')}
          </h2>
        </div>
        <p className="text-base mb-6 flex-grow">
          {t('welcome.description')}
        </p>
        <div className="space-y-4">
          <button 
            onClick={() => setShowContactModal(true)}
            className="btn-neobrutalism bg-neobrutalism-green block w-full text-xs sm:text-base py-2 sm:py-3 px-2 sm:px-4"
          >
            {t('welcome.contactUs')}
          </button>
          <button 
            onClick={() => window.open('https://ranch.gr', '_blank')}
            className="btn-neobrutalism bg-neobrutalism-green block w-full text-xs sm:text-base py-2 sm:py-3 px-2 sm:px-4"
          >
            {t('welcome.findOutMore')}
          </button>
        </div>
      </div>

      {/* Contact Modal */}
      {showContactModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="card-neobrutalism max-w-2xl w-full mx-4 relative">
            <button 
              onClick={() => setShowContactModal(false)}
              className="absolute -top-3 -right-3 w-8 h-8 bg-neobrutalism-red border-2 border-black rounded-full flex items-center justify-center shadow-brutal-sm hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-none transition-all"
              aria-label="Close"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            <h2 className="text-2xl font-black text-neobrutalism-text mb-6">
              {t('contact.title')}
            </h2>
            
            <div className="space-y-6">
              {/* Ranch Location */}
              <div>
                <h3 className="font-bold text-lg mb-2">{t('contact.ranchLocation')}</h3>
                <p>{t('contact.ranchAddress')}</p>
                <p className="mt-2">
                  <span className="font-bold">T:</span> +30 2741093800
                </p>
              </div>

              {/* Central Office */}
              <div>
                <h3 className="font-bold text-lg mb-2">{t('contact.centralOffice')}</h3>
                <p>{t('contact.officeAddress')}</p>
                <p className="mt-2">
                  <span className="font-bold">T:</span> +30 2104100121
                </p>
                <p>
                  <span className="font-bold">&nbsp;&nbsp;&nbsp;&nbsp;</span> +30 2104100122
                </p>
              </div>

              {/* Email address */}
              <div>
                <h3 className="font-bold text-lg mb-2">{t('contact.emailAddress')}</h3>
                <p className="mt-2">
                  <span className="font-bold">E:</span> info@ranch.gr
                </p>
              </div>


              {/* Working Hours */}
              <div>
                <p className="text-sm text-gray-600">{t('contact.workingHours')}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
} 